import {throwError as observableThrowError,  BehaviorSubject ,  Observable, of } from 'rxjs';

import { Injectable, EventEmitter } from '@angular/core';

import { WksBusinessModel, AccountModel } from '../models/wks-business.model';
import { WksEntityModel } from '../models/wks-entity.model';
import { WksEquipmentModel } from '../models/wks-equipment.model';

import { WksWorksInterventionModel, WksWorksModel, WorkQuotation, WksWorksTracking, WorkEquipments, WorkEquipmentRef} from '../models/wks-works.model';
import { OrderParts, PartsRequirement, TaskrefJsonModel, TasksActionCompletedModel, TasksActionsContentModel, TasksActionsModel, WksTasksModel } from '../models/wks-param.model';
import { WksCentralService } from './wks-central.service';
import { LabelValue } from '../../../models/data.model';


@Injectable({
    providedIn: 'root'
})


export class WksWorksService {

    ownerCur: WksBusinessModel;
    entityCur: WksEntityModel;
    mainEquipmentCur: WksEquipmentModel;
    wksOthersWorks: LabelValue[];
    wksWorksIntervention: WksWorksInterventionModel;

    setOwner(_ownerCur: WksBusinessModel) {
        this.ownerCur = _ownerCur;
    }
    getOwner(): WksBusinessModel {
        return this.ownerCur;
    }
    setEntity(_entityCur: WksEntityModel) {
        this.entityCur = _entityCur;
    }
    getEntity(): WksEntityModel {
        return this.entityCur;
    }
    getMainEquipment(): WksEquipmentModel {
        return this.mainEquipmentCur;
    }
    setMainEquipment(_mainEquipmentCur: WksEquipmentModel) {
        this.mainEquipmentCur = _mainEquipmentCur;
    }
    getOthersWorks(): LabelValue[] {
        return this.wksOthersWorks;
    }
    setOthersWorks(_wksOthersWorks: LabelValue[]) {
        this.wksOthersWorks = _wksOthersWorks;
    }
    setWksIntervention( wksWorks: WksWorksModel, owner: WksBusinessModel, account: AccountModel) {

        this.wksWorksIntervention = {
            workIdPrevious: wksWorks.workIdPrevious,
            workObject: wksWorks.workObject,
            workTicket:  wksWorks.workTicket,
            workCriticality: wksWorks.workCriticality,
            workPlanningId: wksWorks.workPlanningId,
            workComment: wksWorks.workComment,
            workLocation: wksWorks.workLocation,
            workLocationData: wksWorks.workLocationData,
            workPosition: wksWorks.workPosition,
            workStatut: wksWorks.workStatut,
            workStatutDate: wksWorks.workStatutDate,
            calendarEventBdd: (wksWorks !== undefined && wksWorks.wksCalendar ? wksWorks.wksCalendar : undefined),
        };
        if ((wksWorks.workJsonQuotation !== null) && (wksWorks.workJsonQuotation !== undefined)) {
            const workQuotation = JSON.parse(wksWorks.workJsonQuotation) as WorkQuotation;
            // this.wksWorksIntervention.delayValidity = workQuotation.delayValidity;
            this.wksWorksIntervention.customerConditions = workQuotation.customerConditions;
            if ((workQuotation.specificsFinancials !== null) && (workQuotation.specificsFinancials !== undefined)) {
                this.wksWorksIntervention.specificsFinancials = workQuotation.specificsFinancials;
            } 
            this.wksWorksIntervention.customerFinancials = workQuotation.customerFinancials;
            if ((workQuotation.specificsConditions !== null) && (workQuotation.specificsConditions !== undefined)) {
                this.wksWorksIntervention.specificsConditions = workQuotation.specificsConditions;
            }
        }
    }
    getWksIntervention(): WksWorksInterventionModel {
        return this.wksWorksIntervention;
    }
    fillTracking(workArg: WksWorksModel, usernameArg: string, workStatutArg: string, workCommentArg: string ): WksWorksModel  {
        const wksWorks = JSON.parse(JSON.stringify(workArg));
        let wksWorksTracking: WksWorksTracking[] = [];
        wksWorks.statutChange = true;
        if (wksWorks.workJsonData !== undefined) {
          const workJsonData = JSON.parse(wksWorks.workJsonData);
          if (workJsonData !== null && workJsonData.wksWorksTracking) {
            wksWorksTracking = JSON.parse(JSON.stringify(workJsonData.wksWorksTracking));
          }
        }
    
        wksWorksTracking.push({
          numberTrack: (wksWorksTracking.length === 0) ? 0 : wksWorksTracking.length,
          userLogged: usernameArg,
          recordedTrack: undefined,
          workStatut: workStatutArg,
          workComment: workCommentArg,
          alarmsMes: undefined
          });
        
        wksWorks.wksWorksTracking =  wksWorksTracking;
        return wksWorks;
    }
    /*=========================================================================== ordrerdParts */
    getListEquipments(tasksActionsContent: TasksActionsContentModel, mainEquipmentObject: WksEquipmentModel , subEquipmentsObject: WksEquipmentModel[] ): WksEquipmentModel[] {
        const localListEquipments: WksEquipmentModel[] = [];

        if (tasksActionsContent.equipments.all) {
            if (subEquipmentsObject !== undefined && subEquipmentsObject.length > 0) {
                for (const equipmentCur of subEquipmentsObject) {
                    localListEquipments.push(equipmentCur);
                }
            } else {
            localListEquipments.push(mainEquipmentObject);
            }
        } else  {
            for (const equipIdCur of tasksActionsContent.equipments.equipId) {
                if (equipIdCur === mainEquipmentObject.id ) {
                    localListEquipments.push(mainEquipmentObject);
                    continue;
                } else {
                for (const equipmentCur of subEquipmentsObject) {
                    if (equipmentCur.id = equipIdCur) {
                        localListEquipments.push(equipmentCur);
                        break;
                    }
                }
            } 
        }
    }
    return localListEquipments;
  }
     // répertir les pièces réservées ou non par BL
    repartOrdersParts(partsRequirementAll:  PartsRequirement[]): OrderParts[] {
        const ordersParts: OrderParts[] = [];
        // orders parts
        let orderRefTmp = '';
        let idxOrderCur = 0 ;
        for (const partItem of  partsRequirementAll) {
            if (partItem.nws_order_ref === undefined) {
                orderRefTmp = 'NOT_RESERVED';
            } else {
                orderRefTmp = partItem.nws_order_ref;
            }
            let isOrderFound = false;
            for (const orderItem of ordersParts) {
                if (orderItem.nws_order_ref !== orderRefTmp) {
                    continue;
                } 
                isOrderFound = true;
                if (orderItem.partsRequirement === undefined) {
                    orderItem.partsRequirement = [];
                }
                orderItem.partsRequirement.push(partItem);
            }
            if (!isOrderFound) {
                const orderTmp: OrderParts = {
                    nws_order_ref: orderRefTmp,
                    nws_order_id: partItem.nws_order_id,
                    idxOrder: idxOrderCur,
                    actionOrder: orderRefTmp === 'NOT_RESERVED' ? 'reserveStockParts' : 'removeOrderParts',
                    partsRequirement: []
                };
                orderTmp.partsRequirement.push(partItem);
                ordersParts.push(orderTmp);
                idxOrderCur++;
            }
        }
        return ordersParts;
    }
    // trier les pièces réservées
    sortOrderedParts(partsRequirementTasks:  PartsRequirement[], orderedParts: PartsRequirement[]): PartsRequirement[] {
        const sortedOrdersPart: PartsRequirement[] = [];
        let isFound = false;
        for (const orderedPartItem of orderedParts) {
            sortedOrdersPart.push(orderedPartItem);
        }
        for (const partTaskItem of partsRequirementTasks) {
            isFound = false;
            let orderedPartCur: PartsRequirement;
            for (const orderedPartItem of orderedParts) {
                if (orderedPartItem.partSupplieId === partTaskItem.partSupplieId) {
                    isFound = true;
                    orderedPartCur = orderedPartItem;
                    break;
                }
            }
            if (!isFound) { // new parts 
                partTaskItem.nws_order_ref = 'NOT_RESERVED' ;
                sortedOrdersPart.push(partTaskItem);
            } else { // additional parts
                if (orderedPartCur.quantity < partTaskItem.quantity) {
                    const partTaskCur = JSON.parse(JSON.stringify(partTaskItem));
                    partTaskCur.quantity = partTaskItem.quantity - orderedPartCur.quantity;
                    partTaskCur.nws_order_ref = 'NOT_RESERVED' ;
                    sortedOrdersPart.push(partTaskCur);
                }
            }
        } 
        return sortedOrdersPart;
    }
    initListPartsFromTasks(workCur: WksWorksModel): PartsRequirement[] {
        
        let suppliesActionsSelected: TasksActionsModel[] = [];
        let partsRequirementBdd: PartsRequirement[] = [];
        let partsRequirement: PartsRequirement[] = [];

        const partsRequirementNeeded: PartsRequirement[] = [];

        let equipments: {
            all: boolean;
            equipId: string[];
        };


        let workEquipmentId: WorkEquipmentRef;
        let numberEquip = 0;
        workEquipmentId = JSON.parse(workCur.workEquip);
        if (workEquipmentId.subEquipments === undefined || workEquipmentId.subEquipments.length === 0) {
            numberEquip = 1;
        } else {
            numberEquip = workEquipmentId.subEquipments.length;
        }

        let equipmentsCur = 0;
        if (workCur.workTasksContent === null || workCur.workTasksContent === undefined) {

            return;
        }
        for (const taskCur of workCur.workTasksContent) {
            suppliesActionsSelected = [];
            const taskrefJson = JSON.parse( taskCur.taskrefJson) as TaskrefJsonModel;
            if (taskrefJson.tasksActionsParentContent !== undefined) {
                const tasksActionsParentContent = taskrefJson.tasksActionsParentContent as TasksActionsContentModel;
                suppliesActionsSelected = tasksActionsParentContent.supplies;
            }
            if (taskrefJson.tasksActionsContent !== undefined) {
                const tasksActionsContent = taskrefJson.tasksActionsContent as TasksActionsContentModel;
                suppliesActionsSelected.push(...tasksActionsContent.supplies);
                equipments = tasksActionsContent.equipments;
                if (equipments.all) {
                    equipmentsCur = numberEquip;
                } else {
                    equipmentsCur = equipments.equipId.length;
                }
                // console.log(tasksActionsContent);
            }
            for (const actionItem of suppliesActionsSelected ) {
                let isFound = false;
                for (const partsRequirementItem of partsRequirementNeeded) {
                    if (actionItem.partSupplieId === partsRequirementItem.partSupplieId) {
                    partsRequirementItem.quantity = actionItem.quantity * equipmentsCur;
                    isFound = true;
                    break;
                    }
                } // end lopp partsRequirementNeeded
                if (!isFound) {
                    const itemPartsRequirement: PartsRequirement = {
                    partSupplieId: actionItem.partSupplieId,
                    partSupplieLabel: actionItem.actionrefLabel,
                    brandRef: actionItem.brandRef,
                    replacesReference: '',
                    actionTask: actionItem.actionTask,
                    billingUnit: actionItem.billingUnit,
                    quantity: actionItem.quantity * equipmentsCur,
                    outputStock: 0,
                    inputStock: 0,
                    movementStock: 0,
                    inStock: 0,
                    nws_order_id: undefined,
                    nws_order_ref: undefined,
                    withdrawal: 'no',
                    partAdded: false
                    };
                    partsRequirementNeeded.push(itemPartsRequirement);
                }
            } // end loop suppliesActionsSelected
            if (taskrefJson.partsRequirement !== undefined) {
                partsRequirementBdd = taskrefJson.partsRequirement;
                // ouputstock already done
                for (const itemBdd of partsRequirementBdd ) {
                    for (const itemNeeded of partsRequirementNeeded) {
                        if (itemBdd.partSupplieId === itemNeeded.partSupplieId) {
                            itemNeeded.outputStock = itemNeeded.outputStock + itemBdd.outputStock;
                            break;
                        }
                    }
                }
            }
        } // end loop workTasksContent
        partsRequirement = JSON.parse(JSON.stringify(partsRequirementNeeded));
        return partsRequirement;
    }
    /*=========================================================================== valid checkList */

    fillModelTasksCompleted(workCur: WksWorksModel, tasksActionsCompleted: TasksActionCompletedModel[], workEquipments: WorkEquipments , entity: string ): void {
        let workTasksContent: WksTasksModel[];
        workTasksContent = workCur.workTasksContent;

        let tasksActionCompletedTmp: TasksActionCompletedModel[];
        for (const taskCur of workTasksContent) {
            tasksActionCompletedTmp = [];
            let isFound = false;
            for (const taskCompletedCur of tasksActionsCompleted) {
                if (taskCompletedCur.taskrefId === taskCur.taskrefId) {
                    tasksActionCompletedTmp.push(taskCompletedCur);
                    isFound = true;
                    break;
                }
            }
            if (isFound) {
                const taskrefJsonTmp = JSON.parse( taskCur.taskrefJson) as TaskrefJsonModel;
                taskrefJsonTmp.tasksActionCompleted = tasksActionCompletedTmp;
                taskCur.taskrefJson = JSON.stringify(taskrefJsonTmp);
                // console.log(taskCur.taskrefJson);
            }
        } // end existants tasks on works
        // New task
        for (const taskCompletedCur of tasksActionsCompleted) {
            let isFound = false;
            for (const taskCur of workTasksContent) {
                if (taskCompletedCur.taskrefId === taskCur.taskrefId) {
                isFound = true;
                break;
                }
            }
            if (isFound) {
                this.verifPriceCompleted(workCur.workTasksContent, taskCompletedCur);
                continue;
            }
            this.verifPriceCompleted(workCur.workTasksContent, taskCompletedCur);
            const newTask: WksTasksModel = {
                id: undefined,
                workId: workCur.id,
                equipType: taskCompletedCur.equipType,
                equipBrand: taskCompletedCur.equipBrand,
                equipModel: taskCompletedCur.equipModel,
                stdEntity: entity,
                taskrefLabel: taskCompletedCur.taskrefLabel,
                taskrefId: taskCompletedCur.taskrefId,
                taskrefJson: undefined,
                taskrefRow: 'work',
                taskrefSN: undefined
            };
            
            let taskrefJsonTmp: TaskrefJsonModel;
            tasksActionCompletedTmp = [];
            tasksActionCompletedTmp.push(taskCompletedCur);
            taskrefJsonTmp = {
                tasksActionsContent: undefined,
                tasksActionsParentContent: undefined,
                tasksActionCompleted: tasksActionCompletedTmp
            };
            newTask.taskrefJson = JSON.stringify(taskrefJsonTmp);
            workCur.workTasksContent.push(newTask);
        }
        for (const taskCompletedCur of tasksActionsCompleted) {
            // SN and hours equipment
            // Main equipment
            if (taskCompletedCur.equipId === workEquipments.mainEquipment.id) {
                if (taskCompletedCur.equipSN !== undefined
                        && taskCompletedCur.equipSN !== ''
                        && taskCompletedCur.equipSN !== null  ) {
                    workEquipments.mainEquipment.equipSN = taskCompletedCur.equipSN;
                }
                if (taskCompletedCur.equipHours !== undefined
                && taskCompletedCur.equipHours !== 0
                && taskCompletedCur.equipHours !== null  ) {
                    workEquipments.mainEquipment.equipHours = taskCompletedCur.equipHours;
                }
            }
            // sub equipments
            if (workEquipments.subEquipments) {
                for (const equipCur of workEquipments.subEquipments) {
                    if (taskCompletedCur.equipId === equipCur.id) {
                        if (taskCompletedCur.equipSN !== undefined
                                && taskCompletedCur.equipSN !== ''
                                && taskCompletedCur.equipSN !== null  ) {
                                equipCur.equipSN = taskCompletedCur.equipSN;
                        }
                        if (taskCompletedCur.equipHours !== undefined
                        && taskCompletedCur.equipHours !== 0
                        && taskCompletedCur.equipHours !== null  ) {
                            equipCur.equipHours = taskCompletedCur.equipHours;
                        }
                    }
                }
            }
        }
    }
    saveWksWorksCheckList(workCur: WksWorksModel, workEquipments: WorkEquipments,  wksCentralService: WksCentralService): Promise<any> {
        return new Promise((resolve, reject) => {
            wksCentralService.saveWksWorks(workCur, 'checklist').subscribe(result => {
              const reponseCur = result.body;
              resolve(reponseCur);
            },
            err => {
              console.log(err);

              reject(err.status);
            });
          });
    }
    saveEquipments(workEquipments: WorkEquipments,  wksCentralService: WksCentralService): any {

    if (workEquipments.subEquipments) {
        for (const equipCur of workEquipments.subEquipments) {
          if ((equipCur.equipSN !== undefined && equipCur.equipSN !== '' && equipCur.equipSN !== null  ) 
            || (equipCur.equipHours !== undefined && equipCur.equipHours !== 0  && equipCur.equipHours !== null )) {
              this.saveWksEquipment(equipCur, wksCentralService)
              .then ((reponseCur) => {
                }, (err: any) => {
                    console.log(err);
              }); 
            }
        }
      } else {
        if ((workEquipments.mainEquipment.equipSN !== undefined && workEquipments.mainEquipment.equipSN !== '' && workEquipments.mainEquipment.equipSN !== null  ) 
          || (workEquipments.mainEquipment.equipHours !== undefined && workEquipments.mainEquipment.equipHours !== 0 && workEquipments.mainEquipment.equipHours !== null )) {
            this.saveWksEquipment(workEquipments.mainEquipment, wksCentralService)
            .then ((reponseCur) => {
              }, (err: any) => {
                  console.log(err);
            }); 
        }
        
      }
    }
    saveWksEquipment( equipItem: WksEquipmentModel,  wksCentralService: WksCentralService): Promise<any> {
        return new Promise((resolve, reject) => {
            wksCentralService.saveWksEquipment(equipItem, 'update').subscribe(result => {
                const reponseCur = result.body;
                resolve(reponseCur);
            },
            err => {
              console.log(err);

              reject(err.status);
            });
        });
    }
    verifPriceCompleted(workTasksContent: WksTasksModel[], tasksActionCompleted: TasksActionCompletedModel): void {

        let tasksActions: TasksActionsContentModel;
        let suppliesTask: TasksActionsModel[] = [];
        let worksTask: TasksActionsModel[] = [];
        let servicesTask: TasksActionsModel[] = [];
        let isFounded = false;
        let itemTask = 0;
        for (const taskRefContent of workTasksContent) {
            if (taskRefContent.taskrefId !== tasksActionCompleted.taskrefId) {
                itemTask++;
                continue;
            }
            isFounded = true;
            suppliesTask = [];
            worksTask = [];
            servicesTask = [];
            const taskrefJsonTmp = JSON.parse(taskRefContent.taskrefJson);
            if (taskrefJsonTmp.tasksActionsParentContent !== undefined) {
                tasksActions = taskrefJsonTmp.tasksActionsParentContent as TasksActionsContentModel;
                if (tasksActions.supplies !== undefined) {
                    suppliesTask.push(...tasksActions.supplies);
                }
                if (tasksActions.works !== undefined) {
                    worksTask.push(...tasksActions.works);
                }
                if (tasksActions.services !== undefined) {
                    servicesTask.push(...tasksActions.services);
                }
            } 
            const tasksActionsContent  = taskrefJsonTmp.tasksActionsContent;
            
            if (tasksActionsContent !== undefined) {
                tasksActions = taskrefJsonTmp.tasksActionsContent as TasksActionsContentModel;
                if (tasksActions.supplies !== undefined) {
                    suppliesTask.push(...tasksActions.supplies);
                }
                if (tasksActions.works !== undefined) {
                    worksTask.push(...tasksActions.works);
                }
                if (tasksActions.services !== undefined) {
                    servicesTask.push(...tasksActions.services);
                }
            }
            break;
        }
        if (!isFounded) {
            return;
        }
        for (const worksItem of tasksActionCompleted.works ) {
            if (worksItem.unitPrice === 0 || worksItem.unitPrice === undefined ) {
                for (const worksCur of worksTask) {
                    if (worksCur.brandRef === worksItem.brandRef) {
                        worksItem.unitPrice = worksCur.unitPrice;
                        worksItem.extPrice =  worksItem.unitPrice *  worksItem.quantity;
                    }
                }
            }
        }
        for (const supplieItem of tasksActionCompleted.supplies ) {
            if (supplieItem.unitPrice === 0 || supplieItem.unitPrice === undefined ) {
                for (const suppliesCur of suppliesTask) {
                    if (suppliesCur.brandRef === supplieItem.brandRef) {
                        supplieItem.unitPrice = suppliesCur.unitPrice;
                        supplieItem.extPrice =  supplieItem.unitPrice *  supplieItem.quantity;
                    }
                }
            }
        }
        for (const servicetem of tasksActionCompleted.services ) {
            if (servicetem.unitPrice === 0 || servicetem.unitPrice === undefined ) {
                for (const servicesCur of servicesTask) {
                    if (servicesCur.brandRef === servicetem.brandRef) {
                        servicetem.unitPrice = servicesCur.unitPrice;
                        servicetem.extPrice =  servicetem.unitPrice *  servicetem.quantity;
                    }
                }
            }
        }
        const taskrefJson = JSON.parse(workTasksContent[itemTask].taskrefJson) as TaskrefJsonModel;
        const tasksActionCompletedFinal = taskrefJson.tasksActionCompleted;
        let idxAction = 0;
        for (const completedItem of tasksActionCompletedFinal) {
            if (completedItem.equipId === tasksActionCompleted.equipId) {
                tasksActionCompletedFinal[idxAction] = tasksActionCompleted;
                break;
            }
            idxAction++;
        }
        taskrefJson.tasksActionCompleted = tasksActionCompletedFinal;
        workTasksContent[itemTask].taskrefJson = JSON.stringify(taskrefJson);
    }
}
